<template>
  <el-dialog
    :title="this.projectId === null ? '新增项目' : '编辑项目'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @close="dialogClose"
    custom-class="custom_dialog"
    top="10vh"
  >
    <el-row style="max-height: 450px; overflow-y: auto">
      <el-col :span="22" :offset="1">
        <el-form
          :model="projectForm"
          :rules="projectFormRules"
          ref="projectForm"
          label-width="110px"
          class="demo-ruleForm"
          size="mini"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="项目名称：" prop="Project">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="projectForm.Project"
              autocomplete="off"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称：" prop="Remark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="projectForm.Remark"
              autocomplete="off"
              placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="推荐信息：" prop="Remark1">
            <!-- <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="projectForm.Remark1"
              autocomplete="off"
              placeholder="请输入推荐信息"
            ></el-input> -->
            <!-- <quillEditor v-model="projectForm.Remark1"></quillEditor> -->
            <VueUeditorWrap
              v-model="projectForm.Remark1"
              :config="ueditorConfig"
            ></VueUeditorWrap>
          </el-form-item>
          <el-form-item label="显示顺序：">
            <el-col :span="16">
              <el-form-item class="el-form-item-internal" prop="Sort">
                <el-input
                  v-model="projectForm.Sort"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :max="1000000"
                  autocomplete="off"
                  placeholder="请输入排序序号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-divider>
            <el-link
              type="primary"
              :underline="false"
              @click="showMoreField = !showMoreField"
            >
              高级配置
              <i
                class="el-icon-d-arrow-right"
                :style="
                  this.showMoreField
                    ? 'transform: rotate(-90deg);transition: all .5s'
                    : 'transform: rotate(90deg);transition: all .5s'
                "
              ></i>
            </el-link>
          </el-divider>
          <br />
          <el-form-item
            label="基础分数："
            prop="BasicScore"
            v-show="showMoreField"
          >
            <el-input-number
              v-model="projectForm.BasicScore"
              :step="1"
              :precision="2"
              :controls="false"
            ></el-input-number>
            <br />
            <span style="font-size: 12px; color: #909399">
              <i class="el-icon-s-opportunity"></i>
              设置该项目的基础得分（打分类投票使用）
            </span>
          </el-form-item>
          <el-form-item
            label="自定义票数："
            prop="CustomVoteCount"
            v-show="showMoreField && userRole === 1"
          >
            <el-input-number
              v-model="projectForm.CustomVoteCount"
              :step="1"
              :precision="2"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-show="showMoreField">
            <div slot="label">
              <div>上传图片：</div>
              <div
                style="font-size: 10px; color: #909399"
                v-if="projectForm.ProjectImages.length > 0"
              >
                建议尺寸：<br />
                980*654<br />1024*684<br />1366*912<br />1440*960
              </div>
            </div>
            <div
              style="
                margin: 5px;
                display: inline-block;
                position: relative;
                border: 1px solid #e6e6e6;
                height: 100px;
                width: 150px;
                text-align: center;
                border-radius: 5px;
              "
              v-for="(projectImage, index) in projectForm.ProjectImages"
              :key="index"
            >
              <el-image
                style="height: 100px; border-radius: 5px"
                ref="projectImagesPreviewImage"
                :src="projectImage.ThumbnailUrl"
                class="preview-image"
                fit="fill"
                :preview-src-list="getPrivewImages(index)"
                :title="projectImage.ImageName"
              ></el-image>
              <!-- <el-link
                icon="el-icon-error"
                :underline="false"
                style="position: absolute; right: 0px; top: 0px"
              ></el-link> -->
              <el-button
                icon="el-icon-close"
                title="删除"
                circle
                type="danger"
                style="position: absolute; right: -8px; top: -8px"
                @click="deleteImages(index)"
              ></el-button>
            </div>
            <el-alert
              v-if="projectForm.ProjectImages.length === 0"
              :closable="false"
            >
              暂无图片 <br />建议尺寸： 980*654 1024*684 1366*912 1440*960
            </el-alert>
          </el-form-item>
          <el-form-item v-show="showMoreField">
            <el-upload
              class="upload-demo"
              ref="projectImageUpload"
              :file-list="projectImageFiles"
              action="#"
              accept=".png,.gif,.jpg,.jpeg"
              :limit="10"
              :http-request="projectImageHandleUpload"
              :auto-upload="false"
              :multiple="true"
            >
              <el-button size="small" type="primary">点击选择图片</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item v-show="showMoreField">
            <div slot="label">
              <div>上传文件：</div>
            </div>
            <div
              style="
                margin: 5px 0px;
                display: inline-block;
                position: relative;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
              "
              v-for="(projectFile, index) in projectForm.ProjectFiles"
              :key="index"
            >
              <el-link
                type="primary"
                :href="projectFile.FileUrl"
                target="_blank"
              >
                {{ projectFile.FileName }}
              </el-link>
              <el-link
                type="danger"
                title="删除"
                @click="deleteFiles(index)"
                style="margin-left: 20px; font-size: 12px"
              >
                删除
              </el-link>
            </div>
            <el-alert
              v-if="projectForm.ProjectFiles.length === 0"
              :closable="false"
            >
              暂无文件
            </el-alert>
          </el-form-item>
          <el-form-item v-show="showMoreField">
            <el-upload
              class="upload-demo"
              ref="projectFileUpload"
              :file-list="projectFileList"
              action="#"
              accept=".txt,.png,.gif,.jpg,.jpeg,.mp3,.mp4,.wav,.wmv,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf"
              :limit="10"
              :http-request="projectFileHandleUpload"
              :auto-upload="false"
              :multiple="true"
            >
              <el-button size="small" type="primary">点击选择文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="editProject()"> 确 定 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import voteProjectApi from '../../api/vote/voteProject'
// import VueHtml5Editor from 'vue-html5-editor'
// import html5EditorJs from '../../assets/js/html5Editor/html5Editor'
// const html5Editor = new VueHtml5Editor(html5EditorJs)
// import quillEditor from '@/components/quill/editor.vue'
import ueditorConfig from '../../assets/js/ueditorConfig'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'EditProject',
  components: {
    //   html5Editor
    // quillEditor
    VueUeditorWrap
  },
  data () {
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    return {
      projectForm: {
        Id: null,
        Project: null,
        GroupId: null,
        Remark: null,
        Remark1: null,
        Remark2: null,
        Sort: null,
        BasicScore: 0,
        CustomVoteCount: 0,
        MeetingID: null,
        ProjectImages: [],
        ProjectFiles: []
      },
      projectFormRules: {
        Project: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 1, max: 500, message: '名称长度最多500个字符。', trigger: 'blur' }],
        Remark: [
          //   { required: true, message: '请输入单位名称', trigger: 'blur' },
          { min: 0, max: 1000, message: '单位名称长度最多1000个字符', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      dialogFormVisible: false,
      projectId: null,
      showMoreField: false,
      projectImageFiles: [],
      projectImagesPreviewList: [],
      deleteImageArray: [],
      projectFileList: [],
      deleteFileArray: [],
      ueditorConfig: ueditorConfig,
      userRole: -1
    }
  },
  props: {
    ProjectGroupID: { type: String },
    MeetingID: { type: String },
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    getProject: function () {
      const _this = this
      voteProjectApi.getProject({
        projectId: _this.projectId
      }).then(data => {
        _this.projectForm = data
        if (_this.projectForm.BasicScore || _this.projectForm.CustomVoteCount || _this.projectForm.ProjectImages.length > 0 || _this.projectForm.ProjectFiles.length > 0) {
          _this.showMoreField = true
        }
        // if (_this.projectForm.ProjectImages) {
        //   _this.projectForm.ProjectImages.forEach(function (projectImage) {
        //     _this.projectImagesPreviewList.push(projectImage.ImageUrl)
        //   })
        // }
        _this.projectForm.MeetingID = _this.MeetingID
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    projectImageHandleUpload: function (raw) {
      const _this = this
      _this.projectImageFiles.push(raw.file)
      console.log(_this.projectImageFiles)
    },
    projectFileHandleUpload: function (raw) {
      const _this = this
      console.log(raw.file)
      _this.projectFileList.push(raw.file)
      console.log(_this.projectFileList)
    },
    editProject: function () {
      const _this = this
      _this.$refs.projectForm.validate((valid) => {
        if (valid) {
          _this.openLoading('保存中…')
          _this.$refs.projectImageUpload.submit()
          _this.$refs.projectFileUpload.submit()
          const fd = new FormData()
          fd.append('Id', _this.projectForm.Id ? _this.projectForm.Id : '')
          fd.append('MeetingID', _this.projectForm.MeetingID)
          fd.append('Project', _this.projectForm.Project)
          fd.append('GroupId', _this.projectForm.GroupId)
          fd.append('Remark', _this.projectForm.Remark ? _this.projectForm.Remark : '')
          fd.append('Remark1', _this.projectForm.Remark1 ? _this.projectForm.Remark1 : '')
          fd.append('Remark2', _this.projectForm.Remark2 ? _this.projectForm.Remark2 : '')
          fd.append('Sort', _this.projectForm.Sort ? _this.projectForm.Sort : '')
          fd.append('BasicScore', _this.projectForm.BasicScore ? _this.projectForm.BasicScore : '')
          fd.append('CustomVoteCount', _this.projectForm.CustomVoteCount ? _this.projectForm.CustomVoteCount : '')

          if (_this.deleteImageArray) {
            fd.append('DeleteImages', JSON.stringify(_this.deleteImageArray))
          } else {
            fd.append('DeleteImages', '')
          }
          if (_this.deleteFileArray) {
            fd.append('DeleteFiles', JSON.stringify(_this.deleteFileArray))
          } else {
            fd.append('DeleteFiles', '')
          }

          // fd.append('projectFiles', _this.projectImageFiles)
          this.projectImageFiles.forEach(function (file, index) {
            fd.append('projectImage_' + index, file)
          })
          this.projectFileList.forEach(function (file, index) {
            fd.append('projectFile_' + index, file)
          })

          voteProjectApi.editProjectByImages(fd).then(data => {
            _this.openLoading().close()
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            _this.dialogFormVisible = false
            _this.fatherSubmitDialog()
          }).catch(err => {
            _this.openLoading().close()
            _this.dialogFormVisible = false
            _this.fatherSubmitDialog()
            return err
          })
        } else {
          return false
        }
      })
    },
    openEditProject: function (projectId) {
      this.openLoading()
      this.getCurrentUserRole()
      this.dialogFormVisible = true
      this.projectId = projectId
      this.showMoreField = false
      this.projectImageFiles = []
      this.projectFileList = []
      if (!projectId) {
        this.projectForm = {
          Id: null,
          Project: null,
          GroupId: null,
          Remark: null,
          Remark1: '',
          Remark2: null,
          Sort: null,
          BasicScore: 0,
          CustomVoteCount: 0,
          MeetingID: null,
          ProjectImages: [],
          ProjectFiles: []
        }
        this.projectForm.GroupId = this.ProjectGroupID
        this.projectForm.MeetingID = this.MeetingID
        this.openLoading().close()
      } else {
        this.getProject()
      }
    },
    dialogClose: function (done) {
      const _this = this
      _this.projectImageFiles = []
      _this.deleteImageArray = []
      _this.projectFileList = []
      _this.deleteFileArray = []
    },
    // 解决 每次点开时 默认显示的是上次关闭前的图片问题
    handlePreviewImage (index) {
      const imageViewerChild = this.$refs.projectImagesPreviewImage[index].$children[0]
      console.log(imageViewerChild)
      // 重置图片缩放、旋转样式
      imageViewerChild && imageViewerChild.reset()
      // 每次点击 显示当前点击的图片
      imageViewerChild && (imageViewerChild.index = index)
    },
    // 预览对应当前图片列表
    getPrivewImages (index) {
      const _this = this
      const imgList = []// 所有图片地址
      if (_this.projectForm.ProjectImages.length > 0) {
        if (index === 0) {
          _this.projectForm.ProjectImages.forEach(function (projectImage) {
            imgList.push(projectImage.ImageUrl)
          })
        } else {
          for (let i = index; i < _this.projectForm.ProjectImages.length; i++) {
            imgList.push(_this.projectForm.ProjectImages[i].ImageUrl)
          }
          for (let i = 0; i < index; i++) {
            imgList.push(_this.projectForm.ProjectImages[i].ImageUrl)
          }
        }
      }
      //   // 调整图片顺序，把当前图片放在第一位
      //   const start = tempImgList.splice(index)
      //   const remain = tempImgList.splice(0, index)
      return imgList
    },
    deleteImages: function (index) {
      const _this = this
      _this.deleteImageArray.push(_this.projectForm.ProjectImages[index])
      _this.projectForm.ProjectImages.splice(index, 1)
    },
    deleteFiles: function (index) {
      const _this = this
      _this.deleteFileArray.push(_this.projectForm.ProjectFiles[index])
      _this.projectForm.ProjectFiles.splice(index, 1)
    },
    editorChange: function (event) {
      //   console.log(event)
      //   console.log(this.projectForm.Remark1)
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    }
  },
  created () {

  }
}
</script>
<style lang="less">
</style>
